import { AnalyzeHeader } from '@/features/analyze/components/AnalyzeHeader';
import { Filter } from '@/features/analyze/components/Filter/Filter';
import React, { Ref } from 'react';

export const AnalyzeLayout = ({
  analyzeHeaderRef,
  children,
}: {
  analyzeHeaderRef?: Ref<HTMLDivElement>;
  children: React.ReactNode;
}) => (
  <div className="flex h-full">
    <Filter />

    <div className="flex grow flex-col items-center overflow-y-auto">
      <div
        className="w-full border-b-2 border-primary-teal bg-rw-white px-5 pt-6 lg:px-36 lg:pt-10"
        ref={analyzeHeaderRef}
      >
        <AnalyzeHeader />
      </div>
      {children}
    </div>
  </div>
);
